import React from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import useInsightfulVote from '../hooks/useInsightfulVote';

const InsightfulButton = ({ article, size = 'medium', showText = true }) => {
  const { hasVoted, voteCount, handleVote, isUpdating } = useInsightfulVote(article);
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        onClick={handleVote}
        disabled={hasVoted || isUpdating}
        size={size}
        sx={{ 
          p: 0,
          color: hasVoted ? 'primary.main' : '#FFD700',
          '&:hover': {
            backgroundColor: 'rgba(255, 215, 0, 0.04)'
          }
        }}
      >
        {hasVoted ? <LightbulbIcon /> : <LightbulbOutlinedIcon />}
      </IconButton>
      
      {showText && (
        <Tooltip title="Click the lightbulb icon to mark this article as insightful" arrow>
        <Typography 
          variant={size === 'small' ? 'caption' : 'body2'} 
          sx={{ ml: 0.5 }}
        >
          {voteCount} found this insightful
        </Typography>
        </Tooltip>
      )}
    </Box>
  );
};

export default InsightfulButton;